import { get } from "lodash";
import omitDeep from "omit-deep-lodash";
import { KEYS, SCREENS, USER_TYPES } from "utils/constants";

export const buildGuestProjectDetailState = ({ tracer, status }) => {
  const plainTracer = omitDeep(tracer, "__typename");
  return {
    process: get(plainTracer, "flow.process"),
    tracer: plainTracer,
    status: omitDeep(status, "__typename"),
  };
};

export const redirectAfterDuplicateProject = ({
  duplicateProject,
  tracer,
  statusId,
}) => {
  [KEYS.SUBSCRIPTION_ID, KEYS.STATUS_ID, KEYS.LINK_ID].forEach((key) =>
    localStorage.removeItem(key),
  );
  const uid = get(duplicateProject, "uid");
  const projectId = get(duplicateProject, "id");
  const sourceId = get(tracer, "source.id");
  const url = `${process.env.REACT_APP_BASE_URL}/#${SCREENS.PUBLIC.PROCESSES.INIT.path}/${sourceId}`;
  const params = new URLSearchParams({
    uid,
    p: projectId,
    status: statusId,
  });
  const target = new URL(`${url}?${params.toString()}`, window.location.href);
  window.location.replace(target.href);
  if (window.location.href === target.href) window.location.reload();
};

const toIds = (items) => (items || []).map(({ id }) => id);

const isEligibleUnassignedProject = (project, userId) => {
  const assignedUserIds = toIds(get(project, "assignedUsers"));
  return assignedUserIds.length === 0 || assignedUserIds.includes(userId);
};

// In "Tous les projets", mirrors the MINE scope rules using row data only.
export const isManageableProjectInOrganizationScope = (project, user) => {
  const userId = get(user, "id");
  const authorId = get(project, "author.id");
  const userType = get(user, "meta.type");
  const seeNewProjects = get(user, "params.seeNewProjects", false);

  if (authorId === userId) return true;

  if (seeNewProjects && !authorId) {
    return isEligibleUnassignedProject(project, userId);
  }

  if (userType === USER_TYPES.INTERNAL_SUPERVISOR.type && authorId) {
    const authorPoleIds = toIds(get(project, "author.poles"));
    const userPoleIds = toIds(get(user, "poles"));
    return authorPoleIds.some((poleId) => userPoleIds.includes(poleId));
  }

  if (
    userType === USER_TYPES.BROKER_REPRESENTATIVE.type &&
    !seeNewProjects &&
    authorId &&
    get(project, "author.organization.id") === get(user, "organization.id")
  ) {
    return true;
  }

  return false;
};
